import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { CREDIT_SELECTION_ABC_EXPERIMENT_IDS } from 'constants/experiments';

import type { TAbExperimentsEntityReducer, TExperiments } from '../types';

export const DEFAULT_SELECTION_EXPERIMENTS_VARIANTS = {
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.NEW_FOCUSED_FORM]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.PROMOTION_GROUP_ID]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.DETAILS_BUTTON_TEXT_ID]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.PROMO_TINKOFF_BANNER]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.SUITABLE_OFFERS_BANNER]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.ADDITIONAL_QUESTIONS]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.EXACT_CONDITIONS]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.UTILIZATION_BANKS]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.COLLECTIONS_ENDLESS_TEST]: '3',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.REDIRECT_TO_FRONTEND_V2]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.BENTO_RANKING_MODEL]: '0',
  [CREDIT_SELECTION_ABC_EXPERIMENT_IDS.DOMAIN_REDIRECT]: '0',
};

export const initialState: TAbExperimentsEntityReducer = {
  experiments: DEFAULT_SELECTION_EXPERIMENTS_VARIANTS,
  userId: null,
  isDefaultVariants: false,
};

export const abExperimentsSlice = createSlice({
  name: 'abExperiments',
  initialState,
  reducers: {
    setAbExperimentsInitialData: (state, { payload }: PayloadAction<TAbExperimentsEntityReducer>) => {
      state.experiments = {
        ...payload.experiments,
      };
      state.userId = payload.userId;
      state.isDefaultVariants = payload.isDefaultVariants;
    },

    updateAbExperiments: (state, { payload }: PayloadAction<Partial<TExperiments>>) => {
      state.experiments = {
        ...state.experiments,
        ...payload,
      };
    },
  },
});

export const { setAbExperimentsInitialData, updateAbExperiments } = abExperimentsSlice.actions;
